module.exports = __webpack_public_path__ + "img/hb.5102bbb1.webp";